import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useProviderTags = () => {
  const [providerTags, setProviderTags] = useState({});

  const addProviderTags = useCallback((key, data) => setProviderTags((oldProviderTags) => ({
    ...oldProviderTags,
    [key]: data,
  })), []);

  return {
    providerTags,
    addProviderTags,
  };
};

const [ProviderTagsProvider, useProviderTagsContext] = createUseContext(useProviderTags);

export {
  ProviderTagsProvider,
  useProviderTagsContext,
};
